module.exports = __webpack_public_path__ + "static/media/kraken.c86cacda.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/exchanges/kraken.png
// module id = 104
// module chunks = 0